module.exports = __webpack_public_path__ + "media/images/mobile/logo_s_v-9180a141816ec747f644303278888fbe.gif";